import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { hitApi, dateFormatter } from "../../components/commonAction";
import AccountTabs from "./AccountTabs";

export default function MyTransactions({ pageTitle }) {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);

    const load = (p = page) => {
        setLoading(true);
        hitApi(
            { url: `billing/me/transactions?page=${p}&limit=20`, method: "GET", data: {}, alert: false },
            (resp) => {
                setLoading(false);
                if (resp?.status) setRows(resp.data?.transactions || []);
            }
        );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { load(page); }, [page]);

    const totalPages = rows.length < 20 ? page : page + 1;

    return (
        <div className="pxl_rightBar_assets">
            <Helmet><title>{pageTitle}</title></Helmet>
            <div className="pxl-rb-header-wrap">
                <div className="pxl-headingTop">
                    <h2 className="pxl-rb-header-heading">My Billing</h2>
                </div>
            </div>
            <AccountTabs />

            <div className="pxl-bill-panel">
                <div className="pxl-bill-panel-header">
                    <div>
                        <h3 className="pxl-bill-panel-title">Transaction history</h3>
                        <div className="pxl-bill-panel-sub">All payments and charges on your account. 20 per page.</div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <span className="pxl-bill-panel-count">{rows.length}</span>
                        <button className="pxl-bill-refresh-btn" onClick={() => load(page)}><IconRefresh /> Refresh</button>
                    </div>
                </div>

                <div className="pxl-bill-table-wrap">
                    <table className="pxl-bill-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Type</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Reference</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <>
                                    {[0, 1, 2, 3, 4].map(i => (
                                        <tr key={i}>
                                            <td><span className="pxl-sk" style={{ width: '65%', height: 13, display: 'block' }} /></td>
                                            <td><span className="pxl-sk" style={{ width: '55%', height: 13, display: 'block' }} /></td>
                                            <td><span className="pxl-sk" style={{ width: '45%', height: 13, display: 'block' }} /></td>
                                            <td><span className="pxl-sk" style={{ width: 60, height: 22, borderRadius: 11, display: 'block' }} /></td>
                                            <td><span className="pxl-sk" style={{ width: '70%', height: 13, display: 'block' }} /></td>
                                        </tr>
                                    ))}
                                </>
                            ) : rows.length === 0 ? (
                                <tr><td colSpan="5" className="pxl-bill-table-state-cell">
                                    <EmptyState
                                        icon={<IconReceipt />}
                                        title="No transactions yet"
                                        text="Every payment and charge will appear here. Your full billing history is always available."
                                    />
                                </td></tr>
                            ) : rows.map(r => (
                                <tr key={r._id}>
                                    <td><span className="pxl-bill-cell-date">{dateFormatter(r.createdAt, "D MMM YYYY, h:mm A")}</span></td>
                                    <td><span className="pxl-bill-pill pxl-bill-pill--muted">{r.type}</span></td>
                                    <td><span className="pxl-bill-amt">{r.currency} {Number(r.amount).toFixed(2)}</span></td>
                                    <td>
                                        {r.status === "completed"
                                            ? <span className="pxl-bill-pill pxl-bill-pill--success"><IconDot /> Completed</span>
                                            : r.status === "refunded"
                                                ? <span className="pxl-bill-pill pxl-bill-pill--info">Refunded</span>
                                                : r.status === "failed"
                                                    ? <span className="pxl-bill-pill pxl-bill-pill--danger">Failed</span>
                                                    : <span className="pxl-bill-pill pxl-bill-pill--muted">{r.status}</span>}
                                    </td>
                                    <td>
                                        <span className="pxl-bill-cell-mono">
                                            {r.paypalCaptureId || r.paypalSubscriptionId || r.paypalOrderId || "—"}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                {!loading && (rows.length > 0 || page > 1) && (
                    <div className="pxl-bill-pagination">
                        <span className="pxl-bill-pagination-info">Page {page}</span>
                        <div className="pxl-bill-pagination-btns">
                            <button
                                className="pxl-bill-page-btn"
                                disabled={page === 1}
                                onClick={() => setPage(page - 1)}
                            >
                                ← Previous
                            </button>
                            <button
                                className="pxl-bill-page-btn"
                                disabled={rows.length < 20}
                                onClick={() => setPage(page + 1)}
                            >
                                Next →
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

function EmptyState({ icon, title, text }) {
    return (
        <div className="pxl-bill-empty">
            <div className="pxl-bill-empty-icon">{icon}</div>
            <div className="pxl-bill-empty-title">{title}</div>
            <p className="pxl-bill-empty-text">{text}</p>
        </div>
    );
}

/* ── Icons ── */
function IconReceipt() { return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>; }
function IconRefresh() { return <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>; }
function IconDot()     { return <svg width="6" height="6" viewBox="0 0 6 6" fill="currentColor"><circle cx="3" cy="3" r="3"/></svg>; }
